var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('smart-camera-web',{attrs:{"theme-color":"#1976D2","hide-back-to-host":"","capture-id":""}})}
var staticRenderFns = []

export { render, staticRenderFns }